<div
  class="modal-wrapper"
  *ngIf="showForm"
  [ngClass]="{ loaded: loaded && loaded['loaded'] }"
>
  <div class="wrapper scroll">
    <div
      class="under-wrapper"
      [ngClass]="{
        'with-navigation-bar': navigationBarTitle && !isProductStatusPopup,
        open: animation,
        loaded: loaded && loaded['loaded']
      }"
      sdClickOutside
      (clickOutside)="closeModal($event)"
      #parent
      [parentRef]="parent"
    >
      <div class="navigation-bar">
        <span class="arrow-back ai ai-back" (click)="closeModal($event)"></span>
        <span class="heading5">{{ navigationBarTitle }}</span>
        <div class="img-wrapper cancel" (click)="closeModal($event)">
          <i class="ai ai-cancel"></i>
        </div>
      </div>
      <div class="separator-gray full-height separator-one-half"></div>
      <div class="content-with-form">
        <div (click)="closeModal()" class="close-button">
           <i class="ai ai-cancel"></i>
        </div>
        <div class="right-side">
          <div class="flex-row">
            <div
              class="element-wrapper"
              *ngFor="let subItem of subItems; trackBy: trackByIndex"
              [ngClass]="{ active: subItem.active }"
            >
              <ng-container *ngIf="isObszycie(subItem)">
                <div
                  class="flex-wrapper-checkbox"
                  (click)="cartItemToggle(subItem)"
                >
                  <input
                    type="checkbox"
                    class="primary-checkbox"
                    [checked]="subItem.active"
                  />
                  <span class="checkmark"></span>
                  <p
                    class="font-style-light"
                    [ngClass]="{ 'font-style-semi': subItem.active }"
                  >
                    {{ subItem.product.name }} ({{
                      subItem.product.promotionPrice
                        .toString()
                        .replace(".", ",")
                    }}
                    {{ "general.currency" | translate }}/m)
                  </p>
                  <p class="price" *ngIf="subItem.active">
                    {{ subItem.totalPromotionPriceBrutto | valueWithComma }}
                    {{ "general.currency" | translate }}
                  </p>
                </div>
                <div class="rest-wrapper">
                  <div class="toggle-wrapper" *ngIf="subItem.active">
                    <div
                      class="toggle"
                      (click)="toggleOrderAllBinding(subItem, parentItem)"
                      [ngClass]="{
                        'active-toggle': isSelectedObszycieAll(subItem)
                      }"
                    ></div>
                    <p
                      class="font-style-semi"
                      *ngIf="parentItem.product.isWalkway"
                    >
                      {{ "cart.twoRounds" | translate }}
                    </p>
                    <p
                      class="font-style-semi"
                      *ngIf="!parentItem.product.isWalkway"
                    >
                      {{ "cart.allRounds" | translate }}
                    </p>
                  </div>
                  <div class="wrapper-binding" *ngIf="subItem.active">
                    <input
                      id="'bindingSize'"
                      class="input"
                      [ngClass]="{ disabled: isSelectedObszycieAll(subItem) }"
                      numberFocus
                      [disabled]="isSelectedObszycieAll(subItem)"
                      [placeholder]="'cart.heightBinding' | translate"
                      [value]="(subItem.quantity | valueWithComma:true) + ' ' + subItem.product.quantityUnit"
                      (blur)="updateValueBinding(subItem, valueBindingInput.value)"
                      (keyup)="updateValueBindingByKeyp(subItem, valueBindingInput.value,$event)"
                      #valueBindingInput
                    />
                    <label
                      (click)="valueBindingInput.focus()"
                      class="form-label"
                      for="'bindingSize'"
                      >{{ "cart.heightBinding" | translate }}</label
                    >
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="!isObszycie(subItem)">
                <div
                  class="flex-wrapper-checkbox"
                  (click)="cartItemToggle(subItem)"
                >
                  <input
                    type="checkbox"
                    class="primary-checkbox"
                    [checked]="subItem.active"
                  />
                  <span class="checkmark"></span>
                  <p class="font-style-light" [ngClass]="{ 'font-style-semi': subItem.active }">
                    {{ subItem.product.name }}
                  </p>
                  <ng-container *ngIf=" subItem.totalPromotionPriceBrutto == subItem.totalStandardPriceBrutto " >
                    <p class="price" *ngIf="subItem.active">{{ subItem.totalPromotionPriceBrutto | valueWithComma }} {{ "general.currency" | translate }}</p>
                  </ng-container>
                  <ng-container *ngIf=" subItem.totalPromotionPriceBrutto != subItem.totalStandardPriceBrutto " >
                    <p class="price promotion-dropdown" *ngIf="subItem.active">
                      {{ subItem.totalPromotionPriceBrutto | valueWithComma }}
                      {{ "general.currency" | translate }}
                      <span>
                        {{ subItem.totalStandardPriceBrutto | valueWithComma }} {{ "general.currency" | translate }}
                      </span>
                    </p>
                  </ng-container>
                </div>

                <ng-container *ngIf="subItem.active">
                  <app-dropdown
                    [options]="subItem.allProductOptions"
                    [label]="'width' | translate"
                    [optionFieldName]="'option'"
                    [additionalInfo]="'promotionPrice'"
                    [unit]="'general.currency' | translate"
                    [activeOption]="getActiveOptionFromActiveSubItem(subItem)"
                    [dropdownPrice]="true"
                    (selectedItem)="cartItemOptionChange(subItem, $event)"
                  ></app-dropdown>
                  <app-input-calculator
                    [suffix]="' ' + subItem.product.quantityUnit"
                    [defaultOperationValue]="1"
                    [placeholder]="'length' | translate"
                    [hidePlusAndMinus]="true"
                    [inputValueName]="'inputValueSubItemPopup'"
                    [value]="subItem.quantity"
                    [fraction]="subItem.quantityStep === 1 ? 0 : 2"
                    [disabled]="isLoading"
                    (valueChange)="updateQuantity(subItem, $event)"
                  ></app-input-calculator>
                </ng-container>
              </ng-container>
            </div>
          </div>
          <div class="button-wrapper">
            <div class="button secondary-button" (click)="closeModal(true)">
              {{ "acceptChanges" | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
